<template>
    <div class="rcclQN2" v-show="isShow">
        <div class="bg" @click="onClose()"></div>
        <div class="RestaurantClassfiyTopDetail">
            <div class="rcclQN_productDetail">
                <BannerKV 
                    :banners="images"
                    :isShowDot="false"
                />
                
            </div>

            <div class="RestaurantClassfiyTopDetailNext">
                <div class="RestaurantClassfiyTopDetailNextTop">
                    <div class="RestaurantClassfiyTopDetailNextLeft">
                        <div class="RestaurantClassfiyTopDetailNextLeftTop">{{item.name}} {{item.briefTitle}}</div>
                        <div style="position: absolute;right: 0;top: 0;">
                            <div class="Restaurant_VR" v-if="shipCode!=='SC'&&item.vrUrl&&item.vrUrl.length>0">
                                <a target="_blank" :href="item.vrUrl" @mouseenter="isShowVrQrCode=true" @mouseleave="isShowVrQrCode=false">
                                    查看VR全景
                                </a>
                            </div>
                            <div class="VR_Content_Detail" v-if="item.vrQrCode&&item.vrQrCode.length>0" v-show="isShowVrQrCode">
                                <img :src="item.vrQrCode" />
                                <div class="detailVr_txt">手机扫一扫，体验更方便</div>
                            </div>
                            <div class="Restaurant_Pcp" v-if="item.showPcp&&item.pcPcpUrl">
                                <a :href="item.pcPcpUrl" target="_blank">立即预订</a>
                            </div>
                            <div style="clear: both"></div>
                        </div>

                    </div>
                </div>
                <div class="RestaurantClassfiyTopDetailNextBottom">
                    <div class="RestaurantClassfiyTopDetailNextBottomTop">
                        <div class="Rboard Brief" v-if="item.brief1&&item.brief1.length>0">
                            <div class="RboardImg"></div>
                            <div class="RboardWr">{{item.brief1}}</div>
                        </div>
                        <div class="Rcontain Brief" v-if="item.brief2&&item.brief2.length>0">
                            <div class="RcontainImg"></div>
                            <div class="RcontainWr">{{item.brief2}}
                            </div>
                        </div>
                        <div class="RConsume Brief" v-if="item.brief3&&item.brief3.length>0">
                            <div class="RconsumeImg"></div>
                            <div class="RconsumeWr">{{item.brief3}}</div>
                        </div>
                        <div class="RDressing Brief" v-if="item.brief4&&item.brief4.length>0">
                            <div class="RdressingImg"></div>
                            <div class="RdressingWr">{{item.brief4}}</div>
                        </div>
                        <div class="RTiming Brief" v-if="item.brief5&&item.brief5.length>0">
                            <div class="RtimingImg"></div>
                            <div class="RtimingWr">{{item.brief5}}</div>
                        </div>
                        <div class="Brief6 Brief" v-if="item.brief6&&item.brief6.length>0">
                            <div class="BriefImg"></div>
                            <div class="BriefText">{{item.brief6}}</div>
                        </div>
                        <div class="Brief7 Brief" v-if="item.brief7&&item.brief7.length>0">
                            <div class="BriefImg"></div>
                            <div class="BriefText">{{item.brief7}}</div>
                        </div>
                        <div class="Brief8 Brief" v-if="item.brief8&&item.brief8.length>0">
                            <div class="BriefImg"></div>
                            <div class="BriefText">{{item.brief8}}</div>
                        </div>
                        <div class="Brief9 Brief" v-if="item.brief9&&item.brief9.length>0">
                            <div class="BriefImg"></div>
                            <div class="BriefText">{{item.brief9}}</div>
                        </div>
                    </div>
                    <div style="clear: both;"></div>
                    <div class="RestaurantClassfiyTopDetailNextBottomMiddle">
                        <div class="Qnov">
                            <div class="QnovWrLeft">您可在</div>
                            <div class="QnovShips">
                                <div class='QnovLeft' v-for="(ship, i) in shipTags" :key="('ship_'+i)">
                                    <a class='external' :href='ship.link'>
                                        {{ship.name}}
                                    </a>
                                </div>
                            </div>
                            <div class="QnovWrRight">上体验该设施。</div>
                        </div>
                    </div>
                    <div class="RestaurantClassfiyTopDetailNextBottomBottom">
                        <p class="RestaurantClassfiyTopDetailNextBottomBottomP">
                            {{item.description}}
                        </p>
                    </div>
                </div>
            </div>
          <div v-if="shipCode==='SC'&&item.vrUrl&&item.vrUrl.length>0" class="viewVrMiniSite">
            <a :href="'https://www.rcclchina.com.cn/'+item.vrUrl" target="_blank">
              <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/vrBtn.png" alt="" title="点击进入VR全景看光谱">
            </a>
          </div>
            <span class="RestaurantClassfiyTopDetailTopImgClose"  @click="onClose()">X</span>
        </div>
    </div>
</template>

<script>
const BannerKV = () => import('@/components/BannerKV')
export default {
    name: "ShipExperiencePopup",
    components: {
        BannerKV
    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        onClose: {
            type: Function
        },
        ships: {
            type: Array,
            default () {
                return []
            }
        },
        itemList:{
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            swiperOptions: {
                loop: true
            },
            isShowVrQrCode: false,
            // isShowVrBtn:false,
            vrUrl:'',
            shipCode:''
        }
    },
    methods: {
        bannerImageChange(slide) {
            if (slide == 'prev') {
                this.bannerSwiper.slidePrev()
            } else {
                this.bannerSwiper.slideNext()
            }
        },
        briefStyle (briefText) {
            if (briefText && briefText.length >= 13) {
                return { 'width': '100%'}
            }
            return {}
        }
    },
  beforeMount() {
    // this.itemList.forEach(r=>{
    //   if(r.id===this.item.id){
    //     if(r.vrUrl){
    //       this.vrUrl = r.vrUrl
    //       this.isShowVrBtn = true
    //     }
    //   }
    // })
  },
  computed: {
        shipTags () {
            if (!this.item.ships || this.item.ships.length == 0) {
                return []
            }
            let ships = []
            this.item.ships.split(',').forEach(shipName => {
                const ship = this.ships.find(r=>r.shipCNName==shipName)
                if (ship) {
                    ships.push({
                        name: shipName,
                        link: `/content/taste/ships/${ship.shipCode}`
                    })
                  this.shipCode = ship.shipCode
                }
            })
            return ships
        },
        images () {
            let images = []
            if (this.item && this.item.bannerItems) {
                this.item.bannerItems.forEach(item=> {
                    images.push({
                        image: item
                    })
                })
            }
            return images
        },
    }
}
</script>

<style lang="less" scoped>
.rcclQN2 {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    .bg {
        background: rgba(0,0,0,0.95);
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .RestaurantClassfiyTopDetail {
        position: relative;
        top: 30px;
        z-index: 999;
        background: #fff;
        margin: 0 auto;
        width: 770px;
        min-height: 558px;
    }

    .RestaurantClassfiyTopDetailNext {
        width: 100%;
        margin: 0 auto;
        background-color: #fff;
        .RestaurantClassfiyTopDetailNextTop {
            width: 95%;
            margin: 0 auto;
            border-bottom: 1px dotted #DBDBDB;
            background-color: #fff;
            padding: 10px 0;
            .RestaurantClassfiyTopDetailNextLeft {
                width: 100%;
                position: relative;
                .RestaurantClassfiyTopDetailNextLeftTop {
                    width: 100%;
                    color: #000F57;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 25px;
                }
            }

            .Restaurant_VR, .Restaurant_Pcp {
                position: relative;
                cursor: pointer;
                top: 0;
                font-size: 14px;
                color: #000;
                /* right: 0; */
                background: #FAB300;
                width: 107px;
                text-align: center;
                height: 30px;
                line-height: 30px;
                border-radius: 3px;
                float: right;
                margin-left: 12px;
                 a {
                    font-size: 14px;
                    color: #000;
                }
            }
            .VR_Content_Detail {
                position: absolute;
                background: #fff;
                top: -202px;
                right: 0;
                padding: 10px;
                width: 200px;
                text-align: center;
                z-index: 1;
                img {
                    width: 150px;
                }
                .detailVr_txt {
                    font-size: 14px;
                }
            }
        }

        .RestaurantClassfiyTopDetailNextBottom {
            width: 100%;
            height: 67%;
            padding-left: 10px;
            .RestaurantClassfiyTopDetailNextBottomTop {
                width: 100%;
                height: 20%;
                .Brief {
                    height: auto;
                    display: inline-block;
                    float: left;
                    line-height: 10px;
                    .RboardImg {
                        width: 20px;
                        height: 20px;
                        float: left;
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/Board.png) no-repeat;
                        margin: 5px 0 0 2px;
                    }
                    .RboardWr {
                        width: auto;
                        float: left;
                        margin: 8px 0 0 5px;
                        overflow: hidden;
                        line-height: 20px;
                    }
                    .RcontainImg {
                        width: 22px;
                        height: 20px;
                        float: left;
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/Contain.png) no-repeat;
                        margin: 5px 0 0 0;
                    }
                    .RcontainWr {
                        float: left;
                        margin: 8px 0 0 5px;
                        overflow: hidden;
                        line-height: 20px;
                    }
                    .RconsumeImg {
                        width: 22px;
                        height: 20px;
                        float: left;
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/Consume.png) no-repeat;
                        margin: 5px 0 0 0;
                    }
                    .RconsumeWr {
                        /* height: 20px; */
                        float: left;
                        margin: 8px 0 0 5px;
                        line-height: 20px;
                        overflow: hidden;
                        /* max-width: 90%; */
                    }
                    .RdressingImg {
                        width: 22px;
                        height: 20px;
                        float: left;
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/Dressing.png) no-repeat;
                        margin: 5px 0 0 0;
                    }
                    .RdressingWr {
                        height: 20px;
                        float: left;
                        margin: 8px 0 0 5px;
                        overflow: hidden;
                        line-height: 20px;
                    }
                    .RtimingImg {
                        width: 22px;
                        height: 20px;
                        float: left;
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/Time.png) no-repeat;
                        margin: 5px 0 0 0;
                    }
                    .RtimingWr {
                        float: left;
                        margin: 8px 0 0 5px;
                        line-height: 20px;
                        max-width: 720px;
                    }
                    .BriefImg {
                        width: 16px;
                        height: 19px;
                        float: left;
                        margin: 8px 0 0 7px;
                    }
                    .BriefText {
                        margin: 8px 0 0 5px;
                        overflow: hidden;
                        line-height: 20px;
                    }
                    &.Brief6 .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/1-1.png) no-repeat;
                        background-size: 100% 100%;
                    }
                    &.Brief7 .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/2-1.png) no-repeat;
                        background-size: 100% 100%;
                    }
                    &.Brief8 .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/3-1.png) no-repeat;
                        background-size: 100% 100%;
                    }
                    &.Brief9 .BriefImg {
                        background: url(https://resource.rcclchina.com.cn/rcclQN/image/4-1.png) no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }

        .RestaurantClassfiyTopDetailNextBottomMiddle {
            margin: 5px 0;
            .Qnov {
                padding-left: 10px;
                color: #fff;
                .QnovWrLeft, .QnovWrRight {
                    color: #000;
                }
                .QnovWrLeft {
                    width: 50px;
                    display: inline-block;
                }
                .QnovWrRight {
                    display: inline-block;
                }
                .QnovShips {
                    display: inline-block;
                }
                .QnovLeft {
                    width: 110px;
                    display: inline-block;
                    margin-top: 7px;
                    text-align: center;
                    line-height: 20px;
                    background-color: #006AB7;
                    border-radius: 10px;
                    color: #fff;
                    font-size: 14px;
                    cursor: pointer;
                    padding: 2px 0px;
                    margin-right: 10px;
                }
                a {
                    font-size: 14px;
                    color: #fff;
                    text-decoration: none;
                }
            }
        }

        .RestaurantClassfiyTopDetailNextBottomBottom {
            width: 100%;
            height: 60%;
            padding-left: 10px;
            line-height: 25px;
            color: #999999;
            font-size: 13px;
        }
    }

    .RestaurantClassfiyTopDetailTopImgClose {
        display: inline-block;
        width: 35px;
        height: 35px;
        position: absolute;
        top: 10px;
        right: 10px;
        border-radius: 35px;
        text-align: center;
        line-height: 35px;
        cursor: pointer;
        background-color: #031463;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        z-index: 1;
    }
}
.viewVrMiniSite{
  width: 200px;
  height: 40px;
  margin: 20px auto 0;
  overflow: hidden;
  & img{
    width: 100%;
    height: 100%;
  }
}
</style>